import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import styled from "styled-components";
import heroBg from "../../images/hero-bg.svg";
import RobotBody from "../../images/form-robot-body.inline.svg";
import RobotHands from "../../images/form-robot-hands.inline.svg";
import Section from "../layout/section";
import ActiveCampaignForm from "../forms/active-campaign";
import { media } from "../../includes/breakpoints";
// import { RobotBody, RobotHands } from "./svg/form-robot";

// const desktopBreakpoint = 920;

const Hero = styled(Section)`
  background: #399afd url(${heroBg});
  background-repeat: no-repeat;
  background-position: center bottom;
  /* background-attachment: scroll; */
  /* background-size: contain; */
  color: #fff;

  .logo{
    margin-bottom: 16px;
    /* &.gatsby-image-wrapper [data-main-image]{
      //Disable the fade-in effect
      opacity: 1;
      transition: none;
    } */
  }
  
  .container{
    /* display: block; */
    
    ${media.large`
      display: flex;
      align-items: center;
      min-height: 750px;
    `}
  }
`;
// Hero.defaultProps = {
//   id: 'hero',
// }

// const Title = styled.h1`
//   text-transform: uppercase;
//   font-family: "Anton";
//   font-size: 166px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 0.77;
//   max-width: 60%;
//   margin: .15ex 0;

//   .c1{
//     position: relative;
//     z-index: 3;
//     color: #EBF4FD;
//     /* opacity: .8; */
//   }
//   .c2{
//     position: relative;
//     z-index: 2;
//     color: #D2E7FD;
//     text-indent: .4ex;
//     /* opacity: .7; */
//   }
//   .c3{
//     position: relative;
//     z-index: 1;
//     color: #B9DAFD;
//     /* opacity: .6; */
//   }
// `;

const Title = styled.h1`
  margin: 0;
  ${media.large`
    margin-right: -80px;
  `}

  svg{
    width: 100%;
    height: auto;
    /* width: 80%; */
  }
`;

const SubTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  line-height: 1.25;
  ${media.large`
    font-size: 32px;
  `}
`;

const FormWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 24px;
  ${media.large`
    margin-top: 0;
  `}

  .body, .hands{
    display: none;

    ${media.tiny`
      display: block;
    `}
  }  
  
  .body{
    margin: auto;
    margin-bottom: -105px;
    ${media.large`
      margin-top: -80px;
    `}
  }
  
  .hands{
    margin: auto;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Form = styled.div`
  position: relative;
  margin: auto;
  background: #FFFFFF;
  color: #2F2B2F;
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;

  ${media.tablet`
    padding: 24px;
  `}
  
  ${media.large`
    width: 460px;
  `}

  input, textarea{
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 16px;
    color: #2F2B2F;
    background: #D2E7FD;
    border-radius: 4px;
    border: none;
    font-size: 14px;
    outline-color: #399afd;
    resize: none;

    ::placeholder{
      color: #2F2B2F;
      /* opacity: .7; */
      font-weight: 300;
    }
  }
  button{
    display: block;
    width: 100%;
    box-sizing: border-box;
    background: #FF590B;
    border-radius: 4px;
    border: none;
    padding: 20px;
    color: white;
    cursor: pointer;
  }

  .error-message{
    color: red;
  }
  
  /* .g-recaptcha{ */
  .captcha{
    margin-bottom: 8px;
    height: 78px;
  }

  .cta{
    &:disabled{
      /* opacity: .95; */
      /* filter: grayscale(0.75); */
      cursor: default;
    }

    .spinner{
      transform: scale(2);
    }
  }
`;

const titleSVG = <svg className="title" role="img" width="744" height="400" viewBox="0 0 744 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <title>Experiment Idea Machine</title>
  <path d="M0.295002 398.625V256.325H43.6974L55.6248 343.129L67.5521 256.325H111.286V398.625H85.2775V296.082L68.8774 398.625H43.3661L25.972 296.082V398.625H0.295002ZM120.081 398.625L133.831 256.325H182.037L195.621 398.625H168.619L166.631 375.598H149.403L147.746 398.625H120.081ZM151.556 352.903H164.478L158.183 280.511H156.857L151.556 352.903ZM237.425 399.95C227.044 399.95 218.706 396.692 212.411 390.176C206.226 383.66 203.134 374.715 203.134 363.34V297.739C203.134 283.603 205.95 272.946 211.583 265.767C217.215 258.589 226.05 254.999 238.088 254.999C248.58 254.999 257.028 257.871 263.434 263.614C269.839 269.356 273.042 277.639 273.042 288.462V312.98H244.714V291.941C244.714 287.855 244.217 285.039 243.223 283.492C242.229 281.946 240.518 281.173 238.088 281.173C235.548 281.173 233.781 282.057 232.787 283.824C231.903 285.591 231.462 288.186 231.462 291.61V363.008C231.462 366.763 232.014 369.524 233.118 371.291C234.223 372.948 235.879 373.776 238.088 373.776C242.505 373.776 244.714 370.187 244.714 363.008V337.331H273.373V364.168C273.373 388.023 261.39 399.95 237.425 399.95ZM282.755 398.625V256.325H311.082V307.182H324.501V256.325H352.828V398.625H324.501V334.018H311.082V398.625H282.755ZM364.097 398.625V256.325H391.596V398.625H364.097ZM402.954 398.625V256.325H432.275L445.362 324.41V256.325H472.861V398.625H445.031L430.784 327.392V398.625H402.954ZM485.459 398.625V256.325H542.446V283.824H514.449V311.489H541.286V338.325H514.449V370.96H544.268V398.625H485.459Z" fill="#B9DAFD"/>
  <path d="M42.9772 270.715V128.415H70.4765V270.715H42.9772ZM81.8344 128.415H121.095C131.256 128.415 138.876 131.231 143.956 136.863C149.036 142.496 151.632 150.834 151.742 161.878L152.073 228.472C152.184 242.498 149.754 253.045 144.784 260.113C139.815 267.181 131.587 270.715 120.101 270.715H81.8344V128.415ZM115.463 245.535C120.654 245.535 123.249 242.995 123.249 237.915V164.528C123.249 161.325 122.973 158.951 122.421 157.405C121.979 155.748 121.095 154.644 119.77 154.092C118.445 153.54 116.402 153.263 113.641 153.263H110.493V245.535H115.463ZM163.531 270.715V128.415H220.517V155.914H192.521V183.579H219.358V210.415H192.521V243.05H222.34V270.715H163.531ZM227.99 270.715L241.74 128.415H289.946L303.53 270.715H276.528L274.54 247.689H257.311L255.655 270.715H227.99ZM259.465 224.993H272.386L266.091 152.601H264.766L259.465 224.993Z" fill="#D2E7FD"/>
  <path d="M0.295002 143V0.699822H57.2813V28.199H29.2851V55.8639H56.1217V82.7005H29.2851V115.335H59.1036V143H0.295002ZM64.4227 143L79.6633 67.46L67.5702 0.534166H95.4008L102.855 49.5689L109.316 0.534166H137.312L125.054 67.46L140.294 143H111.47L102.524 87.3389L93.4129 143H64.4227ZM148.805 0.699822H186.409C197.784 0.699822 205.902 4.39951 210.761 11.7989C215.62 19.0879 218.05 29.8004 218.05 43.9365C218.05 58.0727 215.896 68.73 211.589 75.9085C207.282 83.087 199.551 86.6763 188.397 86.6763H176.801V143H148.805V0.699822ZM178.458 60.9993C181.881 60.9993 184.366 60.3919 185.912 59.1771C187.569 57.8518 188.618 56.0296 189.06 53.7104C189.612 51.2807 189.888 47.8571 189.888 43.4396C189.888 37.4759 189.225 33.1688 187.9 30.5183C186.575 27.8677 183.924 26.5425 179.948 26.5425H176.801V60.9993H178.458ZM226.942 143V0.699822H283.929V28.199H255.932V55.8639H282.769V82.7005H255.932V115.335H285.751V143H226.942ZM295.211 0.699822H338.945C345.903 0.699822 351.259 2.30118 355.014 5.5039C358.879 8.59618 361.475 13.0137 362.8 18.7565C364.125 24.3889 364.788 31.6226 364.788 40.4577C364.788 48.5198 363.739 54.8148 361.64 59.3427C359.542 63.8707 355.897 67.0182 350.707 68.7852C355.014 69.6687 358.106 71.8223 359.984 75.2459C361.972 78.6695 362.966 83.3079 362.966 89.1612L362.634 143H334.804V87.3389C334.804 83.3631 334.031 80.823 332.484 79.7187C330.938 78.6143 328.122 78.0621 324.036 78.0621V143H295.211V0.699822ZM330.994 53.3791C334.969 53.3791 336.957 49.0719 336.957 40.4577C336.957 36.7028 336.792 33.8866 336.46 32.0092C336.129 30.1317 335.522 28.8617 334.638 28.199C333.755 27.426 332.484 27.0394 330.828 27.0394H324.202V53.3791H330.994ZM372.833 143V0.699822H400.332V143H372.833ZM411.69 143V0.699822H455.092L467.019 87.5046L478.947 0.699822H522.681V143H496.672V40.4577L480.272 143H454.761L437.367 40.4577V143H411.69ZM535.286 143V0.699822H592.272V28.199H564.276V55.8639H591.113V82.7005H564.276V115.335H594.095V143H535.286ZM603.555 143V0.699822H632.877L645.964 68.7852V0.699822H673.463V143H645.632L631.386 71.7671V143H603.555ZM698.319 143V28.0334H681.422V0.699822H743.71V28.0334H726.812V143H698.319Z" fill="#EBF4FD"/>
</svg>;

// Regarding H1 tags and SEO https://moz.com/blog/h1-seo-experiment
export default ()=><Hero id="hero">
  <div className="content">
    <StaticImage src="../../images/cro-logo.png" alt="Cro Metrics logo" height={50} width={146} className="logo" placeholder="none" loading="eager" layout="fixed" />
    {/* <Title><div className="c1">Experiment</div> <div className="c2">Idea</div> <div className="c3">Machine</div></Title> */}
    <Title>
      {titleSVG}
    </Title>
    <SubTitle>Jumpstart your optimization program.</SubTitle>
  </div>
  <FormWrapper>
    <RobotBody />
    <Form>
      <RobotHands />
      <ActiveCampaignForm formId="6168C59742C6A"/>
    </Form>
  </FormWrapper>
</Hero>;

// export default class Hero extends React.Component<{},{}>{
//   render(){
//     return <HeroStyle id="hero">
//       {this.props.children}
//     </HeroStyle>;
//   }
// }